import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./slider.css";
import { API_MEDIA } from "../../env";

function Slider_lenta({ data }) {
  const [display, setDisplay] = useState(true);
  const [width, setWidth] = useState(500);
  const [view, setView] = useState(false);

  const settings = {
    variableWidth: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    adaptiveHeight: true,
    arrows: view,
    // autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: "progressive",
    // initialSlide: 0,
    // centerMode: true,
    // responsive: [
    //   { breakpoint: 1700, settings: { slidesToShow: 2 } },
    //   { breakpoint: 1280, settings: { slidesToShow: 2 } },
    //   { breakpoint: 1024, settings: { slidesToShow: 2 } },
    //   { breakpoint: 600, settings: { slidesToShow: 1 } },
    // ],
  };

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  //   lazyLoad: true,
  //   // responsive: [
  //   //   { breakpoint: 1024, settings: { slidesToShow: 2 } },
  //   //   { breakpoint: 600, settings: { slidesToShow: 1 } },
  //   // ],
  //   initialSlide: 0,
  //   centerMode: true,
  //   cssEase: "ease",
  // };
  useEffect(() => {
    setView(window.innerWidth < 800 ? false : true);
    // console.log(window.innerWidth);
    // console.log(view);
  }, []);
  return (
    <div className="slider">
      <Slider {...settings}>
        {data &&
          data.map((i) => (
            <div>
              <img src={API_MEDIA + i.image} />
            </div>
          ))}
      </Slider>
    </div>
  );
}

export default Slider_lenta;
